// extracted by mini-css-extract-plugin
export default {"link":"MzFpr","selected":"oH46A","icon":"fZIE8"};